import axios from 'axios'

export const BASE_URL = process.env.REACT_APP_ENDPOINT

export const axiosInstance = axios.create({
    baseURL: BASE_URL,
    timeout: 100000,
})

export const APPLICATION_VERSION = 'V0.9.0'
